module.exports = __webpack_public_path__ + "img/1280.5396dabf.svg";